/** Campaign/creative defaults and platform macro map (used by campaigns service). */

export const sharedReporting = {};
export const savedReporting = {};

export const defaultCampaign = {
  creatives: [],
  data: {
    impressions: 0,
    engagement: 0,
    clicks: 0
  }
};

export const defaultCreative = {
  assets: [],
  type: 'Banner',
  name: 'New creative',
  data: {
    impressions: 0,
    engagement: 0,
    clicks: 0
  },
  trackers: {}
};

export const platformMacros = {
  "Google Ad Manager": {
    clickMacro: "%%CLICK_URL_UNESC%%"
  },
  "Google Campaign Manager": {
    clickMacro: "%c"
  },
  "Google DV360": {
    clickMacro: "${CLICK_URL}",
    conditional: {
      'dealIDRequired': {
        "Deal-ID": "${INVENTORY_SOURCE_EXTERNAL_ID}",
        "Fallback-ID": "%%ADERIZE_fallbackCreative%%"
      }
    }
  },
  "Quantcast": {
    clickMacro: "${CLICK}",
    additional: {
      'data-qcadz-ds': 'yes'
    },
    conditional: {
      'dynamicID': {
        'data-qcadz-dco': 'yes'
      }
    },
    vastSuffix: 'data-qcadz=yes'
  },
  "Cognitiv": {
    clickMacro: "{{CLICK_URL}}",
    additional: {
      "click-escapes": "{{NUM_DEST_URL_ESCAPES}}"
    },
    thirdparty: {
      "Auction-ID": "{{AUCTION_ID}}",
      "User-ID": "{{COGNITIV_PERSON_IID}}",
      "Page-URL": "{{PAGE_URL}}"
    },
    vastSuffix: "tpMacro-Auction-ID={{AUCTION_ID}}&tpMacro-User-ID={{COGNITIV_PERSON_IID}}&tpMacro-Page-URL={{PAGE_URL_ENC}}&tpMacro-Creative-ID={{CREATIVE_ID}}"
  },
  "The Trade Desk": {
    clickMacro: "%%TTD_CLK%%",
    conditional: {
      'dealIDRequired': {
        "Deal-ID": "%%TTD_DEALID%%",
        "Fallback-ID": "%%ADERIZE_fallbackCreative%%"
      }
    }
  },
  "MediaMath": {
    clickMacro: "[UNENCODED_CLICK_REDIRECT]"
  },
  "AdRoll": {
    clickMacro: "[adrclickurl_unesc]"
  },
  "Xandr": {
    clickMacro: "${CLICK_URL}",
    additional: {
      "platform": "xandr",
      "in-preview": "${IS_PREVIEW}",
      "supply-type": "${SUPPLY_TYPE}"
    }
  },
  "Yahoo DSP": {
    clickMacro: '${CLICKURL}'
  },
  "Adform": {
    clickMacro: "%%c1;cpdir="
  },
  "AdTheorent": {
    clickMacro: "[CLICKURL]"
  },
  "Pubmatic": {
    clickMacro: "${CLICK_URL}"
  },
  "StackAdapt": {
    clickMacro: "{{CLICK_URL}}"
  },
  "Converge Digital": {
    clickMacro: "{%click_url_redir%}"
  },
  "Adelphic/Viant": {
    clickMacro: "${ADELPHIC_CLICK_REDIRECT_PROVIDED}"
  }
};
